import { Validators } from '@angular/forms';
import { ControlProperty } from '../../../../../common/models';
import { NUMBER_PATTERN, TruckSize } from '../../../../../common/constants';

export class TruckSizeMappingModel {
  size: TruckSize = null;
  handlingUnitEfforts: number = null;
  loadingMetersEfforts: number = null;

  constructor(params?: Partial<TruckSizeMappingModel>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class TruckSizeMappingForm {
  constructor(
    model: TruckSizeMappingModel,
    public size: ControlProperty<TruckSize> = [model.size, [Validators.required]],
    public handlingUnitEfforts: ControlProperty<number> = [
      model.handlingUnitEfforts,
      [Validators.required, Validators.pattern(NUMBER_PATTERN)],
    ],
    public loadingMetersEfforts: ControlProperty<number> = [
      model.loadingMetersEfforts,
      [Validators.required, Validators.pattern(NUMBER_PATTERN)],
    ],
  ) {}
}
